<template>
  <div class="avecor-table ">
    <v-toolbar dense style="border-top:1px solid #ccc;position:fixed;top:70px;width:100%;background:#FFF !important;z-index:20;border-bottom:1px solid #ccc;"  flat class="pr-4"> 
      <v-toolbar-title >Merkkaamot</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-col cols="2">
        <v-text-field
          :value="printShopsSearchTerm"
          @change="(event) => printShopsSearchTerm = event"
          class="table-search avecor-select"
          label="Etsi merkkaamoja tästä"
          single-line
          hide-details
        ></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <v-btn @click="addPrintShopDialog=true" dark class="avecor-button-global add-button mb-2" color="#000000">Lisää merkkaamo</v-btn>
      <AddPrintShop @close="addPrintShopDialog=false" :visible="addPrintShopDialog" ></AddPrintShop>
    </v-toolbar>
    <div style="position:absolute;top:48px;height:85vh; padding-bottom:10px; width:100%; border-top:1px solid #ccc;">
      <v-data-table
        :headers="headers"
        :items="getPrintShops"
        hide-default-footer
        :search="printShopsSearchTerm"
        :expand="true"
        disable-pagination
        fixed-header
        height="86vh"
        style="padding-top:35px;"
        :dense="true"
        :options="{sortBy:['wholesaleCode'],itemsPerPage:-1}"
      >
        <template v-slot:item="props">
          <!--<td class="text-xs-left">{{ props.item.number }}</td>-->
          <tr style="height:25px;" class="hide-field-details">
            <td class="text-center" style="width:80px;">
              <v-icon 
                v-if="user.uid === 'p2VRFkTz4JUzqkGoTPUt4CWQAxa2'"
                :size="10"
                @click="deleteItem(props.item)"
              >
                far fa-trash-alt
              </v-icon>
            </td>
            <td style="min-width:75px">
              <v-text-field
                  slot="activator"
                  class="avecor-date-picker"  
                  :value="props.item.created_at ? customFormatter(props.item.created_at) : ''"
                  readonly
              ></v-text-field>
            </td>
            <td class="text-xs-left" style="min-width:200px;">
              <v-text-field
                :value="props.item.name"
                @change="v => inlineSaveField(props.item.id,'name',v)"
                class="avecor-select"
              ></v-text-field>
            </td>
            <td class="text-xs-left" style="min-width:200px;">
              <v-autocomplete
                :value="props.item.printFormats"
                :items="settings.printFormats"
                @change="v => inlineSaveField(props.item.id,'printFormats', v)"
                persistent-hint
                item-text="fi"
                item-value="id"
                class="avecor-select"
                multiple
              />
            </td>
            <td class="text-xs-left" style="min-width:200px;">
              <v-text-field
                :value="props.item.address"
                @change="v => inlineSaveField(props.item.id,'address',v)"
                class="avecor-select"
              ></v-text-field>
            </td>
            <td class="text-xs-left" style="min-width:200px;">
              <v-text-field
                :value="props.item.webAddress"
                @change="v => inlineSaveField(props.item.id,'webAddress',v)"
                class="avecor-select"
              ></v-text-field>
            </td>
            <td class="text-xs-left" style="min-width:25px;">
              <v-btn v-if="props.item.webAddress !== undefined && props.item.webAddress !== ''" :href="props.item.webAddress" text target="_blank">
                <v-icon size=12>fas fa-external-link-alt</v-icon>
              </v-btn>
            </td>
            <td class="text-xs-left" style="min-width:150px;">
              <v-text-field
                :value="props.item.username"
                @change="v => inlineSaveField(props.item.id,'username',v)"
                class="avecor-select"
              ></v-text-field>
            </td>
            <td class="text-xs-left" style="min-width:100px;">
              <v-text-field
                :value="props.item.password"
                @change="v => inlineSaveField(props.item.id,'password',v)"
                class="avecor-select"
              ></v-text-field>
            </td>
            <td class="text-xs-left" style="min-width:150px;">
              <v-textarea
                :value="props.item.orderEmail"
                @change="v => inlineSaveField(props.item.id,'orderEmail',v)"
                single-line
                rows=1
                :auto-grow="true"
                class="avecor-select"
              ></v-textarea>
            </td>
            <td style="min-width:200px;">
              <v-textarea
                :value="props.item.contacts"
                @change="v => inlineSaveField(props.item.id,'contacts',v)"
                single-line
                rows=1
                :auto-grow="true"
                class="avecor-select"
              ></v-textarea>
            </td>
            <td style="min-width:200px;">
              <v-textarea
                :value="props.item.comments"
                @change="v => inlineSaveField(props.item.id,'comments',v)"
                single-line
                rows=1
                :auto-grow="true"
                class="avecor-select"
              ></v-textarea>
            </td>
          </tr>
        </template>
        <template slot="no-data">
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import AddPrintShop from './AddPrintShop'

export default {
    components: {
      AddPrintShop
    },
    data: () => ({
      isEditing: false,
      selected: ["Avecor Oy"],
      selections: {},
      dialog: false,
      addPrintShopDialog: false,
      selectedOrderId: null,
      selectedProductId: null,
      table: null,
      search: '',
      headers: [
        { text: ' ', value: '', align: 'center', sortable: false },
        { text: 'Lisätty pvm.', value: 'created_at', align: 'left', sortable: true},
        { text: 'Merkkaamon nimi', value: 'name', align: 'left', sortable: true},
        { text: 'Merkkaustavat', value: 'name', align: 'left', sortable: true},
        { text: 'Osoite', value: 'address', align: 'left', sortable: true},
        { text: 'www-osoite', value: 'webAddress', align: 'left', sortable: true},
        { text: 'linkki', value: '', align: 'center', sortable: false},
        { text: 'Käyttäjätunnus', value: 'username', align: 'left', sortable: true},
        { text: 'Salasana', value: 'password', align: 'left', sortable: true},
        { text: 'Tilaussähköposti', value: 'orderEmail', align: 'left', sortable: true},
        { text: 'Yhteyshenkilöt', value: 'contacts', align: 'left', sortable: true},
        { text: 'Kommentit/Ohjeet', value: 'comments', align: 'left', sortable: false},
      ],
      date: new Date().toISOString().substr(0, 10)
    }),
    watch: {

    },
    mounted() {
      const table = this.$refs.table
    },
    computed: {
      getPrintShops(){
        var printShops = this.printShops
        return Object.keys(this.printShops).map(function(key, index) {
          return printShops[key]
        })
      },
      ...mapFields([
        "settings",
        "user",
        'product.products',
        'printShop.printShops',
        "settings.printShopsSearchTerm",
        "views.salesConsole",
        "company.companies",
        "staff.staff",
        "settings.companySelectedInModel",
      ])
    },
    created () {
      
    },
    methods: {
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      deleteItem (item) {
        console.log(item)
        if (confirm('Do you want to delete?')) {
              this.$store.dispatch('printShop/delete', item.id)
        }
      },
      inlineSaveField(id,field,value){
        this.$store.dispatch('printShop/set', {
          id,
          [field]:value
        }).then(
          this.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Päivitetty", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
        )
      },
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/PrintShopsTable.vue